import React from 'react';

import { P3 } from '@repo/ui/components/Typography';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';

import { Wrapper, Title, Number, Row, Item } from './styles';

const NumberShowcase = ({ slice }) => {
  return (
    <ContentWrapper className="number-showcase" customWidth="1440px">
      <Wrapper>
        {slice.primary.title && (
          <Title semi as="h2">
            {slice.primary.title}
          </Title>
        )}
        <Row>
          {slice.items?.map(({ number, text }, index) => (
            <Item key={index} alignItems="center">
              <Number as="span">{number}</Number>
              <P3>{text}</P3>
            </Item>
          ))}
        </Row>
      </Wrapper>
    </ContentWrapper>
  );
};

export default NumberShowcase;
